import InterventReports from "@/pages/InterventReports/InterventReports.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";


export function routesInterventReports() {


  return [
    {
      path: "/intervention-reports",
      name: "interventRepoortsIt",
      component: InterventReports,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "interventionReports",
            url: "",
          },
        ],
        indexRoute: "intervention-reports",
        permissions: ["intervention_reports"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/intervention-reports",
      name: "interventRepoortsEn",
      component: InterventReports,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "interventionReports",
            url: "",
          },
        ],
        indexRoute: "intervention-reports",
        permissions: ["intervention_reports"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
  ]
}